


































































import { Component, Vue } from 'vue-property-decorator'
import { Notify } from '@/helpers/Notify'
import { Helper } from '@/helpers/Helper'
import { Api } from '@/fetch/Api'
import store from '@/store'
import VueProgrammaticInvisibleGoogleRecaptcha from 'vue-programmatic-invisible-google-recaptcha'
import { loadScript } from 'vue-plugin-load-script'

@Component({
  components: {
    VueProgrammaticInvisibleGoogleRecaptcha,
  },
})
export default class DashboardLogin extends Vue {
  callInProgress = false
  email: string = null
  password: string = null
  rememberMe = false
  checkLoginFailed = false
  LoginDisabled = true

  created() {
    if (this.$route.params.sb !== process.env.VUE_APP_SKIP_CAPTCHA) {
      loadScript('https://www.google.com/recaptcha/api.js?render=explicit')
    }
    setTimeout(this.enableLoginButton, 5000)
  }

  public executeCaptcha() {
    if (this.$route.params.sb !== process.env.VUE_APP_SKIP_CAPTCHA) {
      this.$refs.invisibleRecaptcha1.execute()
    } else {
      this.checkLogin(process.env.VUE_APP_SKIP_CAPTCHA)
    }
  }

  public async checkLogin(recaptchaToken) {
    this.callInProgress = true
    this.checkLoginFailed = false
    try {
      const checkLogin = await Api.checkLogin(this.email, this.password, this.rememberMe, recaptchaToken, Helper.getCurrentDomain())
      if (checkLogin.password_correct) {
        store.commit('setUserAuthStatus', true)
        store.commit('setUserAuthToken', checkLogin.token.token)
        store.commit('setUserAuthExpiration', checkLogin.token.expire_at)
        const redirect = String(this.$route.query.redirect || '/')
        this.$router.push({ path: redirect })
      } else {
        this.checkLoginFailed = true
        Notify.create({
          type: 'error',
          title: typeof checkLogin.message !== 'undefined' ? checkLogin.message : 'Invalid Credentials',
          text: typeof checkLogin.message !== 'undefined' ? '' : 'Email and/or password is not correct.',
        })
      }
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public enableLoginButton() {
    this.LoginDisabled = false
  }
}
